import { PriceTriggerRequirementType } from '@vertex-protocol/client';

export function getIsTriggerPriceAbove(
  triggerCriteriaType: PriceTriggerRequirementType,
): boolean {
  if (
    triggerCriteriaType === 'last_price_above' ||
    triggerCriteriaType === 'oracle_price_above'
  ) {
    return true;
  }

  return false;
}
